export const REGION_COUNTRIES = {
  "Middle East": ["Saudi Arabia", "Kuwait", "Qatar", "Bahrain", "Dubai"],
  Africa: ["Nigeria", "South Africa"],
  "Asia Pacific": ["India", "Malaysia", "Indonesia", "Singapore", "Philippines", "Hong Kong"],
  Europe: [
    "European Union",
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Spain",
    "Sweden",
  ],
  "North America": ["United States", "Canada", "Mexico"],
};

export const DEFAULT_COMPLIANCE = [{ region: "Asia Pacific", country: "India" }];

export function parseComplianceCsv(text) {
  const rows = [];
  const errors = [];
  String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .forEach((line, index) => {
      const [regionRaw, countryRaw] = line.split(",").map((part) => (part || "").trim());
      if (index === 0 && regionRaw.toLowerCase() === "region") return;
      const countries = REGION_COUNTRIES[regionRaw];
      if (!countries || !countries.includes(countryRaw)) {
        errors.push(`Row ${index + 1}: ${regionRaw || "—"}, ${countryRaw || "—"}`);
        return;
      }
      rows.push({ region: regionRaw, country: countryRaw });
    });
  return { rows, errors };
}

export function mergeCompliance(current, extra) {
  const seen = new Set(current.map((item) => `${item.region}|${item.country}`));
  const next = [...current];
  extra.forEach((item) => {
    const key = `${item.region}|${item.country}`;
    if (seen.has(key)) return;
    seen.add(key);
    next.push(item);
  });
  return next;
}
